module.exports = __webpack_public_path__ + "img/films.b88dfe39.jpg";